// extracted by mini-css-extract-plugin
export default {"header":"ProjectHeader_header__YP3Yo"};